export default "__VITE_ASSET__B8jguzK4__"